import { useMemo } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';

function useIsSingleDayPeriod() {
  const { periodStart, periodEnd } = useSelector((state) => state.filters);

  return useMemo(
    () => {
      const isSingleDayPeriod = Boolean(
        periodStart
        && periodEnd
        && moment(periodStart).isSame(periodEnd, 'day')
      );

      return {
        isSingleDayPeriod,
        selectedDay: isSingleDayPeriod ? moment(periodStart) : null,
      };
    },
    [periodStart, periodEnd]
  );
}

export default useIsSingleDayPeriod;
